import { render, staticRenderFns } from "./DriverAppAssetDetail.vue?vue&type=template&id=35cfc57b&scoped=true"
import script from "./DriverAppAssetDetail.vue?vue&type=script&lang=js"
export * from "./DriverAppAssetDetail.vue?vue&type=script&lang=js"
import style0 from "./DriverAppAssetDetail.vue?vue&type=style&index=0&id=35cfc57b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cfc57b",
  null
  
)

export default component.exports